export default __webpack_public_path__ + "static/and-case-1-bc78552e2c85125f6e91757b41f44942.webp";